module.exports = __webpack_public_path__ + "static/media/main_logo.d3f2255d.png";